module.exports = __webpack_public_path__ + "public/img/qd_yd备份@1x.85eb94f6.png";